<template>
  <div>
    <Modal v-model="visible" :width="600" title="修改密码" class="enterprise-modal" :mask-closable="false">
      <Form ref="form" :label-width="100" :model="form" :rules="rules">
        <FormItem label="手机号">
          <Input type="tel" maxlength="11" v-model="account" disabled />
        </FormItem>
        <FormItem label="旧密码" prop="currentPassword">
          <Input type="password" v-model="form.currentPassword" style="width: 75%;" />
          <Button type="primary" @click="handleForgetPW" style="margin-left: 10px;">忘记密码?</Button>
        </FormItem>
        <FormItem label="新密码" prop="newPassword">
          <Input type="password" v-model="form.newPassword" />
        </FormItem>
        <FormItem label="确认密码" prop="confirmPassword">
          <Input type="password" v-model="form.confirmPassword" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button :loading="sureLoading" type="primary" @click="handleSure">
          确认提交
        </Button>
      </div>
    </Modal>
    <ForgetPasswordVue ref="forgetPassword" />
  </div>
</template>
<script>
import { modifypassword } from '@/api/index'
import ForgetPasswordVue from './ForgetPassword.vue'
export default {
  name: 'change-password',
  components: {
    ForgetPasswordVue
  },
  data() {
    return {
      sureLoading: false,
      visible: false,
      rules: {
        account: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur',
          },
        ],
        currentPassword: [
          {
            required: true,
            message: '请输入原密码',
            trigger: 'blur',
          },
          {
            type: 'string',
            min: 6,
            message: '密码不能少于6位数',
            trigger: 'blur',
          },
          {
            type: 'string',
            max: 8,
            message: '密码不能大于8位数',
            trigger: 'blur',
          },
        ],
        newPassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur',
          },
          {
            type: 'string',
            min: 6,
            message: '密码不能少于6位数',
            trigger: 'blur',
          },
          {
            type: 'string',
            max: 8,
            message: '密码不能大于8位数',
            trigger: 'blur',
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value &&
                value !== '' &&
                value.trim() !== '' &&
                value === this.form.currentPassword
              ) {
                callback(new Error('新密码不能与原密码相同'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: '请再次确认密码',
            trigger: 'blur',
          },
          {
            type: 'string',
            min: 6,
            message: '密码不能少于6位数',
            trigger: 'blur',
          },
          {
            type: 'string',
            max: 8,
            message: '密码不能少于6位数',
            trigger: 'blur',
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value &&
                value !== '' &&
                value.trim() !== '' &&
                value !== this.form.newPassword
              ) {
                callback(new Error('两次输入密码必须一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
      form: {
        currentPassword: null,
        newPassword: null,
        confirmPassword: null,
      }
    }
  },
  watch: {
    visible() {
      this.form = this.$options.data().form
      this.$refs.form.resetFields()
    }
  },
  computed: {
    account() {
      return this.$store.state.userInfo.account
    }
  },
  mounted() {
    this.visible = true
  },
  methods: {
    handleForgetPW() {
      this.visible = false
      this.$nextTick(() => {
        this.$refs.forgetPassword.visible = true
      })
    },
    handleSure() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.sureLoading = true
            await modifypassword({
              account: this.account,
              ...this.form,
            })
            this.sureLoading = false
            this.$Message.success('设置成功')
            this.visible = false
          } catch (error) {
            console.log(error)
            this.sureLoading = false
          }
        }
      })
    }
  }
}
</script>
